<template>
  <div class="ref-control-box">
    <span class="text" @click="openDialog">{{ list[0].title }}</span>
    <detail-dialog
      :visible.sync="dialogVisible"
      :data-id="list[0].id"
      :app-id="refSheetAppId"
    ></detail-dialog>
  </div>
</template>

<script>
import { getAppIdInAvailableSheets } from "@/utils/sheet"
import RefControl from "@/components/Sheet/DetailDialog/DataDetail/FieldItem/RefControl"
import { getCompanySheets } from "@/api/sheet/sheet"

export default {
  name: "RefControl",
  extends: RefControl,
  methods: {
    initRefSheetAppId() {
      getCompanySheets().then(data => {
        this.refSheetAppId = getAppIdInAvailableSheets(data, this.control.refSheetId)
      })
    }
  }
}
</script>
